<ng-container>
	@if (!!data.title) {
		<h2 mat-dialog-title class="sh-info-dialog-title">
			<div class="sh-icon-container">
				@if (data.showWarningIcon) {
					<prism-icon class="sh-warning-icon" icon="sh-warning-outline"> </prism-icon>
				}
				@if (data.showBetaIcon) {
					<prism-beta-indicator></prism-beta-indicator>
				}
				{{ data.title }}
			</div>
		</h2>
	}
	@if (data.body) {
		<mat-dialog-content>
			<div mat-dialog-content fxLayout="column" fxLayoutGap="20px">
				@for (line of data.body; track line; let i = $index) {
					<span class="mat-body-2" [innerHtml]="line"></span>
				}
				@if (data.doNotShowDialogId) {
					<span *transloco="let t; prefix: 'scInfoDialog'"
						><prism-checkbox
							id="sh-confirm-dialog-do-not-show"
							(valueChange)="toggleDoNotShowDialog($event.detail)"
							[checked]="doNotShowDialog"
						>
							{{ t('no-show-dialog-again') }}
						</prism-checkbox></span
					>
				}
			</div>
		</mat-dialog-content>
	}
	<mat-dialog-actions fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
		<prism-button cdkFocusInitial id="sh-info-dialog-ok-button" (click)="close()">
			{{ data.okLabel }}
		</prism-button>
	</mat-dialog-actions>
</ng-container>
